<template>

  <div>

    <v-btn
      outlined
      class="text-none mb-4 pl-3 pr-3"
      color="gray12Color"
      style="background: var(--v-whiteColor-base);"
      @click="$router.push(`/sites/${site.id}/campaign/${campaign.id}/keyword-strategy`)"
    >
      <i class="material-icons-outlined mr-1" style="color: var(--v-gray1Color-base); font-size: 1rem;">arrow_back</i> <span style="color: var(--v-blackColor-base);">Back to Keyword Strategy</span>
    </v-btn>
    
    
    <div class="container d-flex flex-column align-center" style="text-align: center;">
      
      <!-- Header -->
      <!--------------------------------->
      <div class="mb-4" style="color: var(--v-gray50Color-base); margin-bottom: 6px; font-size: 1rem;">{{ site.name }}</div>
      
      <div class="card-big-title mb-4 d-flex gap10" style="color: var(--v-blackColor-base); font-size: 1.8rem; font-weight: 700;">
        1-click silo
        <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
          @click="() => {
            $store.commit('setCurrentVideoTutorialToDisplay', {
              title: 'Build a Full SEO Content Silo in 1 Click (No Guesswork)',
              videoLink: 'https://www.youtube.com/embed/2s9stk-kkac',
              description: 'In this video, Heather Cumins, Customer Success Manager at PageOptimizer Pro, walks you through how to build a complete, ready-to-publish SEO content plan - in just one click.',
              time: '3m 53s'
            });
          }">
          videocam
        </span>
      </div>

      <div
        class="mb-8"
        style="max-width: 650px; font-size: 1rem; line-height: 1.5;"
      >
        Use this option to build a silo instantly - it’s perfect if you don’t have a keyword list but have only one target keyword or general topic in mind.
      </div>

      <!-- Form -->
      <!--------------------------------->
      <div class="white-common-box p-5">
        <div style="width: 1000px;">
          <div
            class="d-flex align-center gap5 mb-4"
            style="justify-content: space-between;"
          >
          <div class="d-flex align-center gap5">
            <span style="font-weight: 700; font-size: 1rem; color: var(--v-blackColor-base);">Enter your target keyword or topic</span>
  
            <b-dropdown aria-role="list" position="is-bottom-right" hoverable>
              <template #trigger>
                <i class="material-icons" style="color: var(--v-gray9Color-base);">info</i>
              </template>
  
              <b-dropdown-item custom style="width: 350px;">
                <div>
                  <div class="mb-1 font-weight-bold">How to select a topic:</div>
                  <div class="mb-3">You can enter 1 topic at a time.</div>
                  <div class="d-flex gap10 mb-2">
                    <i class="material-icons-outlined" style="color: #23BF87; font-size: 1rem; margin-top: 2px;">check</i>
                    you can add one topic (keyword), e.g. “relocation to italy”
                  </div>
                  <div class="d-flex gap10">
                    <i class="material-icons-outlined" style="color: #E92F29; font-size: 1rem; margin-top: 2px;">clear</i>
                    try to stay away from very broad keywords such as “italy” or “visa”
                  </div>
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>

            <div class="lang-loc-fields">
              <v-autocomplete dense solo hide-details="auto"
                append-icon="keyboard_arrow_down"
                :items="availableLocations"
                item-text="location_name"
                item-value="location_code"
                v-model="selectedLocation"
                color="grayColor">
              </v-autocomplete>
          
              <v-autocomplete dense solo hide-details
                append-icon="keyboard_arrow_down"
                :items="availableLanguages"
                v-model="selectedLanguage"
                item-text="language_name"
                item-value="language_code"
                color="grayColor">
              </v-autocomplete>
            </div>
            
          </div>
  
          <div
            class="keyword-field-area mb-6"
          >
            <v-text-field
              class="keyword-field"
              outlined
              hide-details
              color="greenColor"
              v-model="topic"
              placeholder="Enter the keyword or topic you want to explore"
            />
          </div>

          <div class="mb-4" style="text-align: left;">
            <v-tooltip top color="transparent">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" style="display: inline-block;">
                  <v-checkbox
                    class="subdomains-checkbox"
                    style="display: inline-flex;"
                    color="#007aff"
                    hide-details
                    :ripple="false"
                    :input-value="!include_subdomains_in_analysis"  
                    @change="include_subdomains_in_analysis = !$event"
                  >
                    <template v-slot:label>
                      <div style="color: var(--v-blackColor-base); font-size: 0.9rem;">
                        Do not include sub-domains in analysis
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </template>
              <div class="white-bg-tooltip small-tooltip" style="color: var(--v-blackColor-base);">
                Only count rankings for URLs on your main site (example.com and www.example.com). Rankings on subdomains (like blog.example.com) will be ignored.
              </div>
            </v-tooltip>
          </div>

          <div class="d-flex justify-start">
            <v-btn
              color="profileAnchorColor"
              class="whiteColor--text mb-3"
              style="text-transform: none;"
              large
              :loading="submitting"
              :disabled="!canProceed || (isWhiteGloveUser && !(isMissionControlSession))"
              @click="() => hasUnlimitedAccess?startResearch():(() => {showSearchKeywordsCostModal = true})()"
            >
              <span style="font-size: 1.1rem;">Create my silo</span>
            </v-btn>
          </div>
  
          <div
            v-if="!hasUnlimitedAccess"
            class="d-flex align-center gap5"
            style="color: var(--v-gray2Color-base);"
          >
            <img v-if="$vuetify.theme.dark" src="/static/icon_credits_dark_mode.svg" /><img v-else src="/static/icon_credits_light_mode.svg" />  {{ KEYWORD_RESEARCH_ONE_CLICK_SILO_PRICE }} POP Credits
          </div>
  
        </div>
        </div>

    </div>

    <hr style="background-color: var(--v-gray12Color-base); height: 1px; margin: 3rem 0;" />

    <div class="container">

      <!-- Footer -->
      <!--------------------------------->
      

      <workflows-part class="mb-15" />

      <!-- Modals -->
      <!--------------------------------->

      <div class="modal search-keywords-cost-modal" :class="{'is-active': showSearchKeywordsCostModal}">
        <div class="modal-background" @click.stop="showSearchKeywordsCostModal = false"></div>
        <div class="modal-content">
          <div class="box modal-container">
            <div class="modal-content-root">
              <p class="title-font is-size-4 mainColor--text">1-click silo</p>
              <div class="mainColor--text message-text" style="font-size: 1rem; line-height: 150%;">
                It will cost {{ KEYWORD_RESEARCH_ONE_CLICK_SILO_PRICE }} POP Credits to build a 1-click silo for you.<br />
              </div>
              <div class="d-flex justify-end gap10 mt-5">
                <v-btn rounded outlined color="mainColor"
                  class="text-none"
                  @click.stop="() => {
                    showSearchKeywordsCostModal = false;
                  }">
                  <span>Cancel</span>
                </v-btn>
                <v-btn rounded color="profileAnchorColor"
                  class="whiteColor--text text-none"
                  @click.stop="startResearch">
                  <span>Create my silo</span>
                </v-btn>
                
              </div>
            </div>
          </div>
          <button
            class="custom-modal-close-btn"
            aria-label="close"
            @click="() => (showSearchKeywordsCostModal = false)">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import languages from '@/consts/dataforseo_languages.json';
import dataForSeoLocations from '@/consts/dataforseo_locations.json';
import WorkflowsPart from './WorkflowsPart.vue';
import {
  KEYWORD_RESEARCH_ONE_CLICK_SILO_PRICE
} from '@/components/plans_constants.js';

export default {
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    WorkflowsPart
  },
  data () {
    return {
      selectedLocation: null,
      selectedLanguage: null,
      include_subdomains_in_analysis: true,

      topic: '',

      showSearchKeywordsCostModal: false,

      submitting: false,
    }
  },
  computed: {
    KEYWORD_RESEARCH_ONE_CLICK_SILO_PRICE () {
      return KEYWORD_RESEARCH_ONE_CLICK_SILO_PRICE
    },
    availableLocations () {
      return dataForSeoLocations.locations;
    },
    availableLanguages () {
      return languages;
    },
    canProceed () {
      if (this.submitting) {
        return false;
      }
      return (this.topic?.length > 0 && Boolean(this.selectedLocation) && Boolean(this.selectedLanguage))
    },
  },
  watch: {
    
  },
  methods: {
    startResearch () {
        this.showSearchKeywordsCostModal = false;
        this.submitting = true;
          
        const formData = {
          campaignId: this.campaign?.id || 0,
          topic: this.topic,
          locationCode: this.selectedLocation,
          languageCode: this.selectedLanguage,
          include_subdomains_in_analysis: this.include_subdomains_in_analysis,
        }

        this.$store.dispatch('siloResearchOneClickSiloCreate', formData)
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            this.$store.commit('triggerAsyncTasksRefresh');
            this.reloadUser()
            this.$router.push(`/sites/${this.site.id}/campaign/${this.campaign.id}/keyword-strategy/one-click-silo/${response.data.report.id}`)
            this.$notify({
              group: 'info', type: 'success',
              text: '1-Click Silo task has started!'
            })
          } else {
            this.$notify({
              group: 'info', type: 'error',
              text: response?.data?.msg || 'Failed to create 1-Click Silo task'
            })
          }
        })
        .finally(() => {
          this.submitting = false
        })
      },
  },
  mounted () {
    if (this.$route.query.initLanguage) {
      this.selectedLanguage = this.$route.query.initLanguage
    } else {
      this.selectedLanguage = this.campaign.languageCode
    }

    if (this.$route.query.initLocation) {
      this.selectedLocation = this.$route.query.initLocation ? Number(this.$route.query.initLocation) : ''
    } else {
      this.selectedLocation = this.campaign.locationCode ? Number(this.campaign.locationCode) : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.keyword-field-area {

  position: relative;

  max-width: 1100px;

  .lang-loc-fields {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .keyword-field {
    ::v-deep {
      fieldset {
        border-color: var(--v-gray12Color-base);
        background-color: var(--v-whiteColor-base);
      }
  
      input {
        font-size: 1rem;
        margin-top: 12px !important;
        margin-bottom: 12px !important;
        line-height: 34px !important;
      }
    }
  }

}


.lang-loc-fields {
  display: flex;
  flex-direction: row;
  gap: 4px;

  ::v-deep {
    .v-select {
      .v-input__slot {
        box-shadow: none !important;
        background-color: var(--v-gray8Color-base) !important;

        input {
          font-size: .95rem;
          color: var(--v-blackColor-base) !important;
        }
      }
    }
  }
}
::v-deep {
  .subdomains-checkbox {
    margin-top: 0;
    padding-top: 0;
    .v-input__slot{
      padding-left: 0 !important;
    }
  }
}
</style>